import { createSlice } from "@reduxjs/toolkit";
import { Tag } from "../config";
import { doAddTag, doDelTag, doFetchTagList, doUpdateTag } from "./tag.action";

interface Meta {
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

interface TagState {
  tags: Tag[];
  searchQuery: string;
  meta: Meta | null;
  loading: boolean;
  error: string | null;
}
const initialState: TagState = {
  tags: [] as Tag[],
  meta: null,
  searchQuery: "",
  loading: false,
  error: null,
};
const tagSlice = createSlice({
  name: "tag",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch list
    builder
      .addCase(doFetchTagList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchTagList.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchTagList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doAddTag.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doAddTag.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(doAddTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doUpdateTag.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doUpdateTag.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const index = state.tags.findIndex(
          (category) => category.tid === action.payload.id
        );

        if (index !== -1) {
          state.tags[index] = {
            ...state.tags[index],
            ...action.payload.data,
          };
        }
      })
      .addCase(doUpdateTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // delete category
    builder
      .addCase(doDelTag.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doDelTag.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        state.tags = state.tags.filter(
          (category) => category.tid !== action.meta.arg
        );
        if (state.meta) {
          state.meta.totalItems -= 1;
        }
      })
      .addCase(doDelTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default tagSlice.reducer;
